import { createI18n } from 'vue-i18n';

const languages = import.meta.glob('./i18n/*.json');
export const defaultLocale = 'en_English_us';
import * as locales from 'vuetify/locale';

async function loadMessages(): { [key: string]: unknown } {
    const messages: { [key: string]: unknown } = {};
    for (const path in languages) {
        const matched = path.match(/([A-Za-z0-9-_]+)\./i);
        const mod = await languages[path]();
        if (matched && matched.length > 1) {
            const locale = matched[1];
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-expect-error
            messages[locale] = mod.default;
            if (locale in locales) {
                // locales[locale] = mod.default;
                messages[locale] = {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-expect-error
                    ...messages[locale],
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-expect-error
                    $vuetify: locales[locale] as { [key: string]: unknown },
                };
            }
        }
    }
    return messages;
}

export const i18n = createI18n({
    legacy: false,
    locale: defaultLocale,
    fallbackLocale: defaultLocale,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    messages: await loadMessages(),
    missingWarn: false,
});
